/* eslint-disable react-hooks/exhaustive-deps */
import { Toaster } from 'react-hot-toast'
import { useEffect, useRef, useState } from 'react'
import { Col, Container, Form, Row } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import CustomButton from '../../../components/Button/CustomButton'
import Breadcrumb from '../../../components/Label/Breadcrumb'
import ModalUpdateQtyDc from '../../../components/modal/dc/ModalUpdateQtyDc'
import api from '../../../config/AxiosInstance'
import { convertDateWithTime } from '../../../helpers/constants'
import * as Common from '../../../utils/Common'
import FilePreviewModal from '../../../components/modal/common/FilePreviewModal'
import DcGeneralInfo from './components/DcGeneralInfo'
import DcSeriesInfo from './components/DcSeriesInfo'
import DcListItems from './components/DcListItems'
import DcDeliveryProof from './components/DcDeliveryProof'
import DcAuditInfo from './components/DcAuditInfo'

function Detail() {
  const seriesNumberRef = useRef(null)
  const deliveryNoteRef = useRef(null)
  const salesInvoiceRef = useRef(null)
  const debounceTimeout = useRef(null)
  const [modalUpdateItem, setModalUpdateItem] = useState(false)
  const [selectedItem, setSelectedItem] = useState()
  const [detail, setDetail] = useState({})
  const [items, setItems] = useState([])
  const [proof, setProof] = useState([])
  const [seriesNumbers, setSeriesNumbers] = useState([])
  const [selectedSeriesNumber, setSelectedSeriesNumber] = useState('')
  const [loadingSeriesNumber, setLoadingSeriesNumber] = useState(false)
  const [loadingDeleteDeliveryProof, setLoadingDeleteDeliveryProof] =
    useState(false)
  const [deliveryNotes, setDeliveryNotes] = useState([])
  const [selectedDeliveryNote, setSelectedDeliveryNote] = useState('')
  const [loadingDeliveryNote, setLoadingDeliveryNote] = useState(false)
  const [salesInvoices, setSalesInvoices] = useState([])
  const [selectedSalesInvoice, setSelectedSalesInvoice] = useState('')
  const [loadingSalesInvoice, setLoadingSalesInvoice] = useState(false)
  const [loadingUploadFile, setLoadingUploadFile] = useState(false)
  const [showPreview, setShowPreview] = useState(false)
  const [previewUrl, setPreviewUrl] = useState('')
  const [previewName, setPreviewName] = useState('')
  const { id } = useParams()

  const handleShowPreview = (url, name) => {
    if (!url) return
    if (url instanceof File) {
      setPreviewUrl(URL.createObjectURL(url))
    } else {
      setPreviewUrl(url)
    }
    setPreviewName(name || 'Delivery Proof')
    setShowPreview(true)
  }

  const loadData = async (targetId = id) => {
    try {
      let detailData = detail || null
      const res = await api.get(`outbound/dcdrafts/detail/${targetId}`)
      const { data } = res.data
      if (res.data.success) {
        setDetail({
          ...data,
          delivery_date_input: data.actual_delivery_date || data?.delivery_date,
          posting_time: detailData?.posting_time || data?.posting_time || ''
        })
        if (!selectedSeriesNumber || selectedSeriesNumber === '') {
          setSelectedSeriesNumber(
            !data?.series_number ? '' : data?.series_number
          )
        }
        if (!selectedDeliveryNote || selectedDeliveryNote === '') {
          setSelectedDeliveryNote(
            !data?.series_delivery_note ? '' : data?.series_delivery_note
          )
        }

        if (!selectedSalesInvoice || selectedSalesInvoice === '') {
          setSelectedSalesInvoice(
            !data?.series_sales_invoice ? '' : data?.series_sales_invoice
          )
        }
        setItems(data?.items)
        setProof(data?.delivery_proof)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const loadSeriesNumberOptions = async (inputValue = '') => {
    try {
      setLoadingSeriesNumber(true)
      const res = await api.get(`/outbound/dcdrafts/${id}/all-series?`, {
        params: {
          type: 'Delivery Confirmation',
          q: inputValue
        }
      })

      if (res.data.success) {
        const options = res.data.data.reduce((acc, data) => {
          acc.unshift({
            value: data.name,
            label: data.name
          })
          return acc
        }, [])
        setSeriesNumbers(options)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingSeriesNumber(false)
    }
  }

  const loadDeliveryNoteOptions = async (inputValue = '') => {
    try {
      setLoadingDeliveryNote(true)
      const res = await api.get(`/outbound/dcdrafts/${id}/all-series?`, {
        params: {
          type: 'Delivery Note',
          q: inputValue
        }
      })

      if (res.data.success) {
        const options = res.data.data.reduce((acc, data) => {
          acc.unshift({
            value: data.name,
            label: data.name
          })
          return acc
        }, [])
        setDeliveryNotes(options)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingDeliveryNote(false)
    }
  }

  const loadSalesInvoiceOptions = async (inputValue = '') => {
    try {
      setLoadingSalesInvoice(true)
      const res = await api.get(`/outbound/dcdrafts/${id}/all-series?`, {
        params: {
          type: 'Sales Invoice',
          q: inputValue
        }
      })

      if (res.data.success) {
        const options = res?.data?.data
          ?.filter((item) => item?.name !== '')
          ?.reduce((acc, data) => {
            acc.unshift({
              value: data.name,
              label: data.name
            })
            return acc
          }, [])
        setSalesInvoices(options)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingSalesInvoice(false)
    }
  }

  const handleChangeInput = (value, type, { action }) => {
    if (action === 'input-change') {
      if (type === 'series_number') {
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current)
        debounceTimeout.current = setTimeout(() => {
          loadSeriesNumberOptions(value)
        }, 500)
      }
      if (type === 'series_delivery_note') {
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current)

        debounceTimeout.current = setTimeout(() => {
          loadDeliveryNoteOptions(value)
        }, 500)
      }
      if (type === 'series_sales_invoice') {
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current)
        debounceTimeout.current = setTimeout(() => {
          loadSalesInvoiceOptions(value)
        }, 500)
      }
    }
  }

  const handleImageChange = async (e) => {
    try {
      setLoadingUploadFile(true)
      const file = e.target?.files?.[0] || e
      if (!file) return
      const res = await api.postForm(`outbound/dcdrafts/upload-proof/${id}`, {
        proof: file
      })
      if (res.data.success) {
        Common.showPopUpSuccessMessage(res.data.message)
        loadData(id)
      } else {
        Common.showPopUpErrorMessage(res.data.message || 'Upload failed')
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingUploadFile(false)
    }
  }

  const funcDeleteImage = async (image) => {
    try {
      setLoadingDeleteDeliveryProof((prev) => ({
        ...prev,
        [image]: true
      }))
      const payload = {
        path: image
      }
      const res = await api.delete(`/outbound/dcdrafts/delete-proof/${id}`, {
        data: payload
      })
      const { success } = res.data
      if (success === true) {
        Common.showPopUpSuccessMessage('Successfully delete image proof')
        loadData(id)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingDeleteDeliveryProof((prev) => ({
        ...prev,
        [image]: false
      }))
    }
  }

  const handleDeleteImage = async (image) => {
    Swal.fire({
      title: 'Delete Delivery Proof?',
      text: `This action can't be repeated!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'red',
      cancelButtonColor: 'gray',
      confirmButtonText: 'Delete'
    }).then(async (result) => {
      if (result.isConfirmed) {
        funcDeleteImage(image)
      }
    })
  }

  const handleSubmit = async () => {
    Swal.fire({
      title: 'Send to ERP?',
      text: `This action can't be repeated!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f89d1d',
      confirmButtonText: 'Send'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const values = {
            series_number: selectedSeriesNumber,
            series_delivery_noted: selectedDeliveryNote,
            series_sales_invoice: selectedSalesInvoice,
            delivery_date: convertDateWithTime(
              detail?.delivery_date_input,
              'YYYY-MM-DD'
            ),
            posting_time: detail?.posting_time
          }
          const res = await api.post(
            `/outbound/dcdrafts/${id}/send-erp`,
            values
          )
          if (res.data.success) {
            if (res.data.data.success === false) {
              throw new Error(res.data.data.err || 'An error occurred')
            }
            Common.showPopUpSuccessMessage(res.data.message)
            loadData(id)
          }
        } catch (err) {
          const errMsg =
            err?.response?.data?.errors?.message ||
            err?.message ||
            'An error occurred'
          Common.showPopUpErrorMessage(errMsg)
        }
      }
    })
  }

  const handleUpdateItem = (data) => {
    setModalUpdateItem(true)
    setSelectedItem(data)
  }

  const buttonSendToErp = () => {
    let disabled = false
    let variant = 'warning'
    if (
      detail?.erp_dc_no ||
      detail?.items?.some(
        (item) => !item?.confirmed_qty?.trim() || !item?.confirmed_qty
      )
    ) {
      return {
        disabled: true,
        variant: 'secondary'
      }
    }
    if (
      selectedSeriesNumber === '' ||
      selectedDeliveryNote === '' ||
      selectedSalesInvoice === '' ||
      !detail?.delivery_date_input ||
      !detail?.posting_time
    ) {
      disabled = true
      variant = 'secondary'
    }
    return {
      disabled,
      variant
    }
  }

  useEffect(() => {
    const fetchInitialData = async () => {
      await loadData(id)
      await new Promise((resolve) => setTimeout(resolve, 2000))
      await loadSeriesNumberOptions()
      await new Promise((resolve) => setTimeout(resolve, 2000))
      await loadDeliveryNoteOptions()
      await new Promise((resolve) => setTimeout(resolve, 2000))
      await loadSalesInvoiceOptions()
    }

    fetchInitialData()
  }, [id])

  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col md={12} className="mt-3">
            <Breadcrumb
              label={detail.wms_dc_no || '-'}
              link="/outbound/dc"
              back="Delivery Confirmation"
            />
          </Col>
        </Row>
        <Row className="mt-3">
          <Form onSubmit={handleSubmit}>
            <div>
              <DcGeneralInfo detail={detail} setDetail={setDetail} />

              <DcSeriesInfo
                detail={detail}
                loadingSeriesNumber={loadingSeriesNumber}
                seriesNumbers={seriesNumbers}
                selectedSeriesNumber={selectedSeriesNumber}
                setSelectedSeriesNumber={setSelectedSeriesNumber}
                seriesNumberRef={seriesNumberRef}
                loadingDeliveryNote={loadingDeliveryNote}
                deliveryNotes={deliveryNotes}
                selectedDeliveryNote={selectedDeliveryNote}
                setSelectedDeliveryNote={setSelectedDeliveryNote}
                deliveryNoteRef={deliveryNoteRef}
                loadingSalesInvoice={loadingSalesInvoice}
                salesInvoices={salesInvoices}
                selectedSalesInvoice={selectedSalesInvoice}
                setSelectedSalesInvoice={setSelectedSalesInvoice}
                salesInvoiceRef={salesInvoiceRef}
                handleChangeInput={handleChangeInput}
              />

              <DcListItems
                detail={detail}
                items={items}
                handleUpdateItem={handleUpdateItem}
              />

              <DcDeliveryProof
                proof={proof}
                loadingDeleteDeliveryProof={loadingDeleteDeliveryProof}
                handleDeleteImage={handleDeleteImage}
                handleShowPreview={handleShowPreview}
                loadingUploadFile={loadingUploadFile}
                handleImageChange={handleImageChange}
              />
            </div>
            {!detail?.erp_dc_no && (
              <div className="d-flex justify-content-end mb-5">
                <CustomButton
                  onClick={handleSubmit}
                  variant={buttonSendToErp().variant}
                  disabled={buttonSendToErp().disabled}
                  text={'Send to ERP'}
                />
              </div>
            )}

            <DcAuditInfo detail={detail} />
          </Form>
        </Row>
      </Container>

      <ModalUpdateQtyDc
        show={modalUpdateItem}
        onHide={() => setModalUpdateItem(false)}
        selectedItem={selectedItem}
        refreshdata={() => loadData(id)}
      />

      <FilePreviewModal
        show={showPreview}
        onHide={() => setShowPreview(false)}
        fileUrl={previewUrl}
        fileName={previewName}
      />
      <Toaster />
    </>
  )
}

export default Detail
